import { useEffect } from "react";
import { withRouter } from "react-router-dom";

//redux
import { useLayout } from "../context/LayoutContext";

const NonAuthLayout = ({ children }) => {
  const { layoutModeType } = useLayout();

  useEffect(() => {
    if (layoutModeType === "dark") {
      document.body.setAttribute("data-layout-mode", "dark");
    } else {
      document.body.setAttribute("data-layout-mode", "light");
    }
  }, [layoutModeType]);
  return <div>{children}</div>;
};

export default withRouter(NonAuthLayout);
